import React from "react";
import { Link } from "@/components/parts/Link";

interface DataStorageNoticeProps {
  className?: string;
}

export const DataStorageNotice: React.FC<DataStorageNoticeProps> = ({
  className,
}) => {
  return (
    <section
      aria-labelledby="data-storage-notice-heading"
      className={`rounded-2xl border border-primary-100 bg-primary-50 p-4 ${className ?? ""}`}
    >
      <h2
        id="data-storage-notice-heading"
        className="text-sm font-bold text-primary-700"
      >
        入力データの保存について
      </h2>
      <p className="mt-2 text-sm text-primary-700">
        入力した体重や年齢などは、次回も続きから使えるようにこのブラウザ内にだけ自動保存しています。この自動保存はブラウザ内で完結し、保存のために内容をサーバーへ送ることはありません。
      </p>
      <p className="mt-2 text-xs text-primary-500">
        共用の端末やブラウザでは、同じブラウザを使う人が保存内容を見られる可能性があります。
      </p>
      <p className="mt-2 text-sm">
        <Link href="/me/">保存されているデータの確認・削除はマイデータへ</Link>
      </p>
    </section>
  );
};
